export class FilterRequestItem {
	constructor(type, values) {
		this.type = type
		this.values = values
	}
}
